<script setup lang="ts">
import { Clock, AlertTriangle, Repeat } from 'lucide-vue-next';

const painPoints = [
    {
        icon: Clock,
        stat: '6–18 mois',
        label: "Durée moyenne d'une revue systématique manuelle",
    },
    {
        icon: AlertTriangle,
        stat: '~30%',
        label: "D'erreurs humaines dans l'extraction manuelle",
    },
    {
        icon: Repeat,
        stat: '2x',
        label: 'Le travail est refait à chaque mise à jour',
    },
];
</script>

<template>
    <section class="border-t border-border/40 py-20">
        <div class="mx-auto max-w-5xl px-4">
            <div class="grid items-center gap-16 lg:grid-cols-2">
                <!-- Narrative side -->
                <div>
                    <span
                        class="mb-4 inline-block text-xs font-medium tracking-widest text-brand uppercase"
                    >
                        Le problème
                    </span>
                    <h2
                        class="text-3xl font-semibold tracking-tight text-foreground sm:text-4xl"
                    >
                        La revue systématique est un processus
                        <span class="text-brand">épuisant</span>
                    </h2>
                    <div
                        class="mt-6 space-y-4 text-base leading-relaxed text-muted-foreground"
                    >
                        <p>
                            Vous passez des semaines à trier des milliers
                            d'articles, à copier-coller des données dans des
                            tableurs, à vérifier manuellement chaque décision.
                            Le risque d'erreur est permanent.
                        </p>
                        <p>
                            Entre les fichiers RIS éparpillés, les PDF non
                            associés et les grilles d'extraction bricolées sur
                            Excel, la rigueur méthodologique souffre. Et quand
                            il faut mettre à jour la revue, tout recommence.
                        </p>
                        <p class="font-medium text-foreground">
                            Il existe une meilleure façon de faire.
                        </p>
                    </div>
                </div>

                <!-- Stats side -->
                <div class="space-y-6">
                    <div
                        v-for="point in painPoints"
                        :key="point.stat"
                        class="flex items-start gap-5 rounded-2xl border border-border/40 p-6 transition-colors hover:border-border"
                    >
                        <div
                            class="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-red-500/10"
                        >
                            <component
                                :is="point.icon"
                                class="h-5 w-5 text-red-500/80"
                            />
                        </div>
                        <div>
                            <p
                                class="text-2xl font-semibold tracking-tight text-foreground"
                            >
                                {{ point.stat }}
                            </p>
                            <p class="mt-1 text-sm text-muted-foreground">
                                {{ point.label }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
